import React from "react";
import { Autocomplete, TextField, InputLabel } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import {
  FilterRowItem,
  MultiSelectCheckbox,
  MultiSelectLi,
  MultiSelectText,
} from "./styles";

export const AutoCompleteField = ({
  label,
  options,
  filterKey,
  placeholder,
  ...rest
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { optionValues, labelByValue } = React.useMemo(() => {
    const opts = options || [];
    const isObject = opts.length > 0 && typeof opts[0] === "object";
    return {
      optionValues: isObject ? opts.map((o) => o.value) : opts,
      labelByValue: isObject
        ? Object.fromEntries(opts.map((o) => [o.value, o.label]))
        : {},
    };
  }, [options]);

  const getLabel = (val) => labelByValue[val] ?? val;

  const onFilterValueChange = (e, data) => {
    e.preventDefault();
    setSearchParams((params) => {
      if (!data?.length) params.delete(filterKey);
      else params.set(filterKey, data);
      if (filterKey === 'profession') params.delete('subprofession');
      return params;
    });
  };

  const value = React.useMemo(() => {
    const val = searchParams.get(filterKey) || "";
    if (!val) return [];
    return val.split(",");
  }, [searchParams]);

  return (
    <FilterRowItem>
      <InputLabel>{label}</InputLabel>
      <Autocomplete
        {...rest}
        multiple
        value={value}
        disableCloseOnSelect
        sx={{ minWidth: 300 }}
        options={optionValues}
        getOptionLabel={getLabel}
        onChange={onFilterValueChange}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} />
        )}
        renderOption={(props, option) => (
          <MultiSelectLi {...props}>
            <MultiSelectCheckbox checked={value.indexOf(option) > -1} />
            <MultiSelectText primary={getLabel(option)} />
          </MultiSelectLi>
        )}
      />
    </FilterRowItem>
  );
};
